import { render, staticRenderFns } from "./Auftraege.vue?vue&type=template&id=2aeb41db"
import script from "./Auftraege.vue?vue&type=script&lang=js"
export * from "./Auftraege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports